import React from "react";

const HeaderPadding = () => {
	return <div style={{paddingTop: "4.5rem"}}/>;
};

export default HeaderPadding;
